import breadcrumbs from './Favourites_breadcrumbs';
import api from '../../api/index';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
  },
  state: {
    unfavourite_modal: false,
    selected_number  : 10,
    selected_page    : 1,
    fav_pages        : 1,
    sorting          : '',
    tab              : 'all',
    search_string    : '',
    types            : ['news', 'events', 'actions', 'database'],
    favourites       : [],
  },
  getters: {
    favourites       : ({favourites}) => favourites,
    types            : ({types}) => types,
    fav_pages        : ({fav_pages}) => fav_pages,
    selected_page    : ({selected_page}) => selected_page,
    unfavourite_modal: ({unfavourite_modal}) => unfavourite_modal,
    selected_number  : ({selected_number}) => selected_number,
    tab              : ({tab}) => tab,
    sorting          : ({sorting}) => sorting,
    search_string    : ({search_string}) => search_string,
    filtered_by_type({favourites=[]}, {tab}) {
      if (tab!='all') {
        if (tab=='actions') {
          return favourites.filter((item)=> item.type == 'actions');
        } else if (tab=='database') {
          return favourites.filter((item)=> item.type == 'glossary' || item.type == 'oem' || item.type == 'classification' || item.type == 'product');
        } else if (tab=='events') {
          return favourites.filter((item)=> item.type == 'event');
        } else if (tab=='news') {
          return favourites.filter((item)=> item.type == 'news');
        }
      } else {
        return favourites;
      }
    },
    search_by_string: ({search_string}, {filtered_by_type})=> {
      if (filtered_by_type.length > 0) {
        return filtered_by_type.filter((x)=> x.title ? x.title.toLowerCase().includes(search_string.toLowerCase()) : x);
      }
    },
  },
  mutations: {
    CLOSE_MODAL(state) {
      state.unfavourite_modal = false;
    },
    OPEN_MODAL(state) {
      if (!state.unfavourite_modal) {
        state.unfavourite_modal = true;
      }
    },
    SET_PAGES_COUNT(state, value) {
      state.fav_pages = value;
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SET_ACTIVE_TAB(state, value) {
      state.tab = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    CLEAR_PAGES(state) {
      state.selected_page = 1;
    },
    SORT_BY_DATE(state, selected) {
      if (selected=='Сначала новые') {
        state.sorting = 'desc';
      } else if (selected=='Сначала старые') {
        state.sorting = 'asc';
      }
    },
    SEARCH_STRING(state, value) {
      state.search_string = value;
      state.selected_page = 1;
    },
    TO_FAVOURITES(state, obj) {
      state.favourites.push(obj);
    },
    REMOVE_FAVOURITES(state, id) {
      let current_idx = state.favourites.findIndex((item)=> item.id == id);
      if (state.favourites.length) {
        state.favourites.splice(current_idx, 1);
      }
    },
    SET_FAVORITES(state, value) {
      state.favourites = value.content;
      if (state.favourites.length > 0) {
        state.favourites.forEach((x)=> {
          if (x.date && typeof x.date== 'object') {
            x.forEach((y)=>y.date = y.date*1000);
          } else if (x.date) {
            x.date = x.date*1000;
          }
        });
      }
    },
  },
  actions: {
    show_number({dispatch, commit, getters}, event) {
      const {filtered_by_type} = getters;
      commit('CLEAR_PAGES');
      commit('SHOW_NUMBER', {array: filtered_by_type, selected: event});
      dispatch('get_favorites');
    },
    sorting_by_date({commit, dispatch}, selected) {
      commit('SORT_BY_DATE', selected);
      commit('CLEAR_PAGES');
      dispatch('get_favorites');
    },
    async get_favorites({commit, getters}) {
      let {selected_number, selected_page, search_string, tab, sorting} = getters;
      let sort = sorting || 'asc';
      let tab_selected = tab=='all' ? '' : tab;
      try {
        let favorites = await api.favorite.get_favorite(selected_number, selected_page, search_string, tab_selected, sort);
        commit('SET_FAVORITES', favorites.data);
        commit('SET_PAGES_COUNT', favorites.data.page_count);
      } catch (err) {
        console.error(err);
      }
    },
    async add_to_favourites({commit, rootGetters}, obj) {
      let current_tab = rootGetters['database/current_tab'];
      let data = {
        type: obj.database_id ? current_tab : obj.type,
        id  : obj.database_id ? obj.database_id : obj.id,
        name: obj.title,
      };
      try {
        await api.favorite.add_favorite(data);
        commit('TO_FAVOURITES', obj);
      } catch (err) {
        console.error(err);
      }
    },
    async remove_from_favourites({commit}, id) {
      try {
        await api.favorite.delete_favorite(id);
        commit('REMOVE_FAVOURITES', id);
      } catch (err) {
        console.error(err);
      }
    },
    async toggle_favourites({dispatch}, obj) {
      let id = obj.database_id ? obj.database_id : obj.id;
      if (obj.favourite) {
        await dispatch('remove_from_favourites', Number(id));
      } else {
        await dispatch('add_to_favourites', obj);
      }
    },
  },
};
